import { createAction } from '@reduxjs/toolkit';
import { shopCouponCodesSlice } from './reducer';

export const { receiveShopData, resetShopData } = shopCouponCodesSlice.actions;

export const fetchShopData = createAction('shopCouponCodes/fetchShopData');
